interface HeroSectionProps {
}

const HeroSection: React.FC<HeroSectionProps> = () => {
    return (
        <>
            <div className="text-center justify-center lg:max-w-4xl mx-auto md:mt-9 mb-5 md:mb-10">
                <h1 className="text-balance text-3xl md:text-4xl leading-snug text-green-900 relative">
                    <span className="inline-flex px-4 py-1 rounded-md before:content-['Start_with_these_ideas'] before:animate-typing before:overflow-hidden before:whitespace-nowrap before:border-r-2 before:border-white before:block"></span>
                </h1>
            </div>
        </>
    );
};

export default HeroSection;